'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = require('react-bootstrap/lib/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Navbar2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Navbar.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Navbar.js
 ** module chunks = 0
 **/